import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/services/auth';

// Client-side UX gate only — the real boundary is Laravel's role middleware (ADR-0019).
// Render nothing until the session resolves so admin UI never flashes for guests; then
// redirect anyone below owner back to the portal.
export function AdminGate({ children }: { children: ReactNode }) {
  const { user, isLoading } = useSession();

  if (isLoading) return null;
  if (!user || user.role === 'registered_guest') return <Navigate to="/" replace />;

  return <>{children}</>;
}
